// extracted by mini-css-extract-plugin
export default {"title":"LoginForm_title__N-PLw"};